<div class="page-header non-transparent-header vpb-6 convo-info-wrapper">
  <div class="convo-info {{isMobile? 'vmy-3':'vmt-5 vmb-3'}}">
    <div class="text-center vmb-1 position-relative">
      <img *ngIf="!isMobile" class="position-absolute top-0 end-0 -mt-2" width="169px"
        src="assets/img/signup/styling.png" alt="">
      <div class="title home-heading m-0" *ngIf="!isMobile">Sign Up Now</div>
      <p class="title fs-4 text-bold home-description vpt-3 vmb-3 ">Take our Style Quiz to Get Matched with Products
        You’ll Love</p>
      <!-- <p class="title home-description text-muted pt-2 vpb-2"> First, pick the categories you’d like personal product recommendations from:</p> -->
      <i style="color:#8862a2">Already a Qatch member? Login <a style="color:#8862a2"
          routerLink="../signin">here!</a></i>
    </div>
    <p-blockUI *ngIf="loading" [blocked]="true">
      <div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </p-blockUI>
    <!-- <q-convo class="d-block mx-auto" [loading]="convoCardsLoading" [convoCards]="convoCards" (onUpdate)="onUpdateConvoCards($event)" [isMobile]="isMobile"></q-convo> -->
    <form class="convo-form mx-auto rounded-inputs-form vmt-3 w-100%" [formGroup]="convoForm" autocomplete="off"
      autocapitalize="off">
      <div class="convo-form-section vmt-3 px-md-0" *ngIf="convoForm">
        <div class="col-12 mb-2 p-0">
          <div class="form-group mb-0">
            <div class="input-group form-group-no-border border-custom"
              [ngClass]="{ 'valid': convoForm.get('name')?.valid }">
              <input type="text" class="form-control" placeholder="Enter name" formControlName="name">
              <i *ngIf="convoForm.get('name')?.valid" class="bi bi-check-circle-fill text-success check-icon"></i>
            </div>
          </div>
          <uikit-error [submitted]="isSubmittedOnce" [controls]="convoControls" name="name" placeholder="Name">
          </uikit-error>
        </div>
        <div class="col-12 mb-2 p-0 pt-3">
          <div class="input-group form-group-no-border bg-default shadow border-custom"
            [ngClass]="{ 'valid': convoForm.get('phone_number')?.valid }">
            <span class="input-suffix">{{countryCode}}</span>
            <input class="form-control box-shadow-none numberinput-no-arrows" appPhoneMask
              formControlName="phone_number">
            <i *ngIf="convoForm.get('phone_number')?.valid" class="bi bi-check-circle-fill text-success check-icon"></i>
          </div>
          <uikit-error [submitted]="isSubmittedOnce" [controls]="convoControls" name="phone_number"
            placeholder="phone number">
          </uikit-error>
          <small *ngIf="!convoForm.get('phone_number')?.dirty" class="phone-input-hint pt-1">Currently only available in the U.S. and Canada</small>
        </div>
        <div class="col-12 mb-2 p-0 {{!convoForm.get('phone_number')?.dirty ? 'pt-2' : 'pt-3'}}">
          <div class="form-group mb-0">
            <div class="input-group form-group-no-border border-custom"
              [ngClass]="{ 'valid': convoForm.get('email')?.valid }">
              <input type="text" class="form-control" placeholder="Email" formControlName="email">
              <i *ngIf="convoForm.get('email')?.valid" class="bi bi-check-circle-fill text-success check-icon"></i>
            </div>
          </div>
          <uikit-error [submitted]="isSubmittedOnce" [controls]="convoControls" name="email" placeholder="Email">
          </uikit-error>
        </div>

        <div class="d-flex {{isMobile? 'align-items-center' : ''}}  col-12 mb-4 p-0 pt-3" style="font-size: 12px;">
          <bSwitch [switch-on-color]="'primary'" [switch-off-color]="'default'" [switch-off-text]="'No'"
            [switch-on-text]="'Yes'" formControlName="agree_to_terms" required style="height: fit-content;">
          </bSwitch>
          <div class="vml-2">
            <div class="term_and_conditions" (click)="toggleTerms()">By selecting “YES”, you are opting into Qatch’s service where
              you will receive up to 10 personalized product recommendations weekly and links to those products that we think you
              will love. You also agree to our Terms of Service. Qatch may receive commission from products purchased through links
              sent via text. For help, text HELP or email us at <a href="mailto:sendhelp@joinqatch.com">sendhelp&#64;joinqatch.com</a>. To take a break, just text us “PAUSE” and to
              cancel at any time, text us “STOP.” Message and Data rates may apply. By opting in, you agree to our terms here:
              <a [routerLink]="['/terms']">https://www.joinqatch.com/terms</a> and our privacy policy here: <a [routerLink]="['/terms']">https://joinqatch.com/privacy</a>
            </div>
          </div>
        </div>
        <div class="col-12 d-xl-flex justify-content-center">
          <div class="col-12 col-xl-5 d-flex justify-content-center ">
            <q-button title="LET'S GO" type="arrowButton" [disabled]="loading || !convoForm.valid"
              buttonStyleClass="btn-purple" iconStyleClass="btn-dark-purple" [loading]="loading"
              (onBtnClick)="validatePhoneNumber();">
            </q-button>
          </div>
        </div>
        <div class="col d-flex justify-content-center justify-content-xl-start align-items-center text-center ps-xl-3">
          <p class="title text-bold home-description m-0 pt-3 pt-xl-1">Tell Us About Your style On The Next Page 👉 </p>
        </div>
      </div>
    </form>
  </div>
</div>